var _desc, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGoogleIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created using Figma")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "google-icon_svg__google-icon_svg__Canvas",
    transform: "translate(101 1367)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "google-icon_svg__google-icon_svg__Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "google-icon_svg__google-icon_svg__Google_+"
  }, /*#__PURE__*/React.createElement("g", {
    id: "google-icon_svg__google-icon_svg__back"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#google-icon_svg__google-icon_svg__path0_fill",
    transform: "translate(-100.965 -1367)",
    fill: "#DC4E41"
  })), /*#__PURE__*/React.createElement("g", {
    id: "google-icon_svg__google-icon_svg__Combined_Shape"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#google-icon_svg__google-icon_svg__path1_fill",
    transform: "translate(-92.964 -1355.8)",
    fill: "#FFFFFF"
  })))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "google-icon_svg__google-icon_svg__path0_fill",
    fillRule: "evenodd",
    d: "M 0 16C 0 7.16344 7.16437 0 16.0021 0C 24.8398 0 32.0042 7.16344 32.0042 16C 32.0042 24.8365 24.8398 32 16.0021 32C 7.16437 32 0 24.8365 0 16Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "google-icon_svg__google-icon_svg__path1_fill",
    fillRule: "evenodd",
    d: "M 5.09155 6.08002L 5.09155 4.34283L 9.89941 4.34283C 9.94312 4.59619 9.97949 4.84955 9.97949 5.1825C 9.97949 8.0777 8.03015 10.1333 5.09155 10.1333C 2.27661 10.1333 0 7.8678 0 5.06665C 0 2.2655 2.27661 0 5.09155 0C 6.46631 0 7.61548 0.499451 8.50293 1.32458L 7.12097 2.64917C 6.74268 2.28723 6.08081 1.86743 5.09155 1.86743C 3.35315 1.86743 1.93481 3.3006 1.93481 5.06665C 1.93481 6.83276 3.35315 8.26593 5.09155 8.26593C 7.10632 8.26593 7.86279 6.8255 7.97925 6.08002L 5.09155 6.08002ZM 14.5472 4.34283L 16.0021 4.34283L 16.0021 5.79047L 14.5472 5.79047L 14.5472 7.23804L 13.0925 7.23804L 13.0925 5.79047L 11.6378 5.79047L 11.6378 4.34283L 13.0925 4.34283L 13.0925 2.8952L 14.5472 2.8952L 14.5472 4.34283Z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleIcon);
export default __webpack_public_path__ + "static/media/google-icon.74f71c3706dc4868cd069b555cffe487.svg";
export { ForwardRef as ReactComponent };